import { extractApiErrorMessage } from '../../../extract-api-error-message'

/**
 * AllAll Suno 音乐：POST /suno/submit/music
 * 参数：prompt(歌词), mv(模型), title, tags, make_instrumental, task_id, continue_at, continue_clip_id, gpt_description_prompt, notify_hook, task
 * 响应：{ code: 'success', data: taskId, message: '' }
 */

var DEFAULT_MV = 'chirp-v4'

/**
 * 构建 POST /suno/submit/music 的 JSON Body（仅提交用到的 5 个参数）
 * @param {Object} params - prompt, mv, title, tags, make_instrumental
 */
export function buildBody(params) {
  return {
    prompt: (params.prompt || params.lyrics || '').toString().trim(),
    mv: params.mv || DEFAULT_MV,
    title: (params.title || params.songTitle || '').toString().trim(),
    tags: (params.tags || params.styleTags || '').toString().trim(),
    make_instrumental: params.make_instrumental === true
  }
}

/**
 * 解析提交响应，返回 taskId
 * @param {Object} res - axios response, res.data = { code, data, message }
 */
export function parseSubmitResponse(res) {
  var data = res && res.data
  if (!data) return null
  if (data.code !== 'success') {
    throw new Error(extractApiErrorMessage(data) || 'Suno 提交失败')
  }
  return data.data != null ? String(data.data) : null
}
